import { rootDoc } from "../../../../helpers/dom-selectors.js";
import makeHeader from "../../../global-components/header.js";
import PasswordChecker from "../../../global-components/password-check.js";
import makePasswordInput from "../../../global-components/password-input.js";
import SignupForm from "../components/signup-form.js";
import APP_VIEWS from "./event-router.js";
export default function App({ inputPass, showPassBtn, submitBtn, header, logo }) {
    _initAppShell();
    return Object.freeze({
        resize,
        executeEvent
    });
    function _initAppShell() {
        makeHeader({ header, logo }).init();
        makePasswordInput({ inputPass, showPassBtn });
        const passwordChecker = new PasswordChecker(inputPass, submitBtn);
        SignupForm.init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        rootDoc.style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = APP_VIEWS.get(action);
        await view.execute();
    }
}
;
